export default __webpack_public_path__ + "static/media/5_1_4.d7624dda.png";